import { createTranslations } from '@npco/common-utils-translations'

export const cCOutstandingExpenseComingSoonModalTranslations =
  createTranslations({
    modalTitle: 'Outstanding Expenses',
    modalBody:
      'Streamline tax preparation by knowing how many purchases need categorisation, receipts or notes added. Coming soon to Zeller Dashboard.',
  })
